import { Link } from "react-router-dom";
import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { ArrowDownRight } from "lucide-react";
import { IMG } from "../lib/assets";
import { MaskLines } from "./Motion";
import { money } from "../lib/api";

export const Hero = ({ product }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start start", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["0%", "18%"]);
  const scale = useTransform(scrollYProgress, [0, 1], [1.08, 1.2]);
  const textY = useTransform(scrollYProgress, [0, 1], ["0%", "-30%"]);

  return (
    <section ref={ref} data-testid="hero-section" className="relative bg-[#0B0B0B] text-white md:min-h-[100svh] overflow-hidden">
      <div className="relative aspect-[16/10] md:absolute md:inset-0 md:aspect-auto overflow-hidden">
        <motion.img
          src={IMG.ladies}
          alt="Three party-goers in Project X Make Parties Great Again hats"
          style={{ y, scale }}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1.4 }}
          className="absolute inset-0 w-full h-full object-cover object-[50%_35%]"
          data-testid="hero-banner-image"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0B0B0B] via-[#0B0B0B]/30 to-transparent md:via-[#0B0B0B]/20" />
      </div>

      <motion.div style={{ y: textY }} className="relative z-10 px-5 sm:px-10 lg:px-16 pb-12 pt-6 md:pt-0 md:absolute md:inset-x-0 md:bottom-0 md:pb-16">
        <motion.p
          initial={{ opacity: 0, x: -20 }} animate={{ opacity: 1, x: 0 }} transition={{ delay: 0.9 }}
          className="inline-flex items-center gap-3 font-mono-x uppercase text-xs tracking-[0.25em] bg-[#E10600] px-3 py-2 mb-6"
        >
          Drop 001 · Now live
        </motion.p>
        <h1 className="font-display uppercase leading-[0.86] text-[16vw] md:text-[10vw] lg:text-[9.5rem]" data-testid="hero-headline">
          <MaskLines lines={["Make parties", <span key="g">great <span className="text-[#E10600]">again.</span></span>]} />
        </h1>
        <div className="mt-8 flex flex-col sm:flex-row sm:items-end justify-between gap-8">
          <motion.p
            initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 1.2 }}
            className="max-w-md text-base sm:text-lg font-semibold text-zinc-200"
          >
            The official Project X hat. Red, white and built for your whole PARTY LYFE — {money(product?.price)} with {Number(product?.shipping ?? 0) > 0 ? `${money(product?.shipping)} shipping` : "FREE shipping"}.
          </motion.p>
          <motion.div initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 1.35 }}>
            <Link
              to="/shop"
              data-testid="hero-shop-button"
              className="group inline-flex items-center gap-4 bg-white text-[#0B0B0B] px-7 py-5 font-display uppercase text-2xl transition-colors duration-200 hover:bg-[#E10600] hover:text-white"
            >
              Shop the hat
              <ArrowDownRight className="w-6 h-6 transition-transform duration-300 group-hover:-rotate-45" />
            </Link>
          </motion.div>
        </div>
      </motion.div>
    </section>
  );
};
